import a from"./customizeValidator.esm.js";var o=a();export{a as customizeValidator,o as default};
